module.exports = __webpack_public_path__ + "img/product-detail-01.7810b60d.jpg";